module.exports = __webpack_public_path__ + "static/media/eth.00d5f1ff.svg";